<ul>
  @for (child of shownTreeDataStructure!.children; track child; let i = $index) {
    <li>
      <div class="row align-items-center tree-selection-item">
        <div class="col">
          <scitis-toggle-arrow
            class="d-inline-flex mr-1"
            (click)="child.isVisible = !child?.isVisible"
            [isOpen]="child?.isVisible"
            [isInvisible]="!child?.children?.length">
          </scitis-toggle-arrow>
          <input class="mr-2" type="checkbox" [id]="uniqueId+i"
            (click)="onCheck($event, child)"
            [checked]="child?.checked"
            [disabled]="child?.disabled">
            <label class="mb-0" [for]="uniqueId+i" [innerText]="child?.name"></label>
          </div>
          @if (child?.children?.length) {
            <div class="col-auto">
              <div ngbDropdown container="body">
                <button type="button" class="btn btn-link float-right dropdown-no-arrow" id="dropdownBasic1" ngbDropdownToggle>
                  <span class="fa-solid fa-ellipsis-vertical"></span>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button (click)="onSelectAll(child)" ngbDropdownItem>
                    <span class="fa-solid fa-square-check"></span>
                    <span translate>Select subgroups</span>
                  </button>
                  <button (click)="onDeselectAll(child)" ngbDropdownItem>
                    <span class="fa-solid fa-square-xmark"></span>
                    <span translate>Deselect subgroups</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
        @if (child?.isVisible) {
          <scitis-tree-list
            [listOptions]="child"
            [whiteListedMachineryGroups]="whiteListedMachineryGroups"
            (checkboxStatusEmitter)="checkboxStatusEmitter.emit($event)"
            [isRootGroup]="false">
          </scitis-tree-list>
        }
      </li>
    }
  </ul>
